import Companies from "views/pages/companies";
import CompaniesCreate from "views/pages/companies/create";
import CompaniesEdit from "views/pages/companies/edit";
import EventLogsCompany from "views/pages/companies/eventLogs";
import CompaniesLogs from "views/pages/companies/eventLogs";
import Shops from "views/pages/shops";
import NewShop from "views/pages/shops/create";
import EditShop from "views/pages/shops/edit";
import ShopLogs from "views/pages/shops/eventLogs";
import EventLogs from "views/pages/eventLogs";

const routes = [
  // Admin Routes
  {
    exact: true,
    path: "/companies",
    name: "Companies",
    icon: "ni ni-building",
    component: Companies,
    layout: "/admin",
  },
  {
    path: "/companies/create",
    name: "Create Companies",
    component: CompaniesCreate,
    layout: "/admin",
    notSideBar: true,
  },
  {
    path: "/companies/:id/edit",
    name: "Edit Companies",
    component: CompaniesEdit,
    layout: "/admin",
    notSideBar: true,
  },
  {
    path: "/companies/:id/logs",
    name: "Company Logs",
    component: EventLogsCompany,
    layout: "/admin",
    notSideBar: true,
  },
  {
    exact: true,
    path: "/shops",
    name: "Shops",
    icon: "ni ni-shop",
    component: Shops,
    layout: "/admin",
  },
  {
    path: "/shops/:id/edit",
    name: "Edit Shop",
    component: EditShop,
    layout: "/admin",
    notSideBar: true,
  },
  {
    path: "/shops/create",
    name: "Create Shop",
    component: NewShop,
    layout: "/admin",
    notSideBar: true,
  },
  {
    path: "/shops/:id/logs",
    name: "Shop Logs",
    component: ShopLogs,
    layout: "/admin",
    notSideBar: true,
  },
  {
    path: "/companies/:id/logs",
    name: "Companies Logs",
    component: CompaniesLogs,
    layout: "/admin",
    notSideBar: true,
  },
  {
    path: "/event-logs",
    name: "Event Logs",
    icon: "ni ni-calendar-grid-58 text-brand",
    component: EventLogs,
    layout: "/admin",
  },
  // Company Routes
  {
    exact: true,
    path: "/shops",
    name: "Shops",
    icon: "ni ni-shop",
    component: Shops,
    layout: "/company",
  },
  {
    path: "/shops/:id/logs",
    name: "Shop Logs",
    component: ShopLogs,
    layout: "/company",
    notSideBar: true,
  },
  {
    path: "/event-logs",
    name: "Event Logs",
    icon: "ni ni-calendar-grid-58 text-brand",
    component: EventLogs,
    layout: "/company",
  },
];

export default routes;
